import { z } from 'zod';


// =============================================================================
// PLOT OPTION SCHEMA (AI-Generated Ideas)
// =============================================================================

/**
 * Schema for AI-generated plot outline options during brainstorming.
 * This is a complete plot structure suggestion, not yet committed to the project.
 */

export const IdeatedPlotSchema = z.object({
  optionId: z.number().describe("Unique identifier for this plot option."),
  title: z.string().describe("A compelling, one-sentence title for this specific plot version."),
  summary: z.string().describe("A concise, 100-word summary of the plot outline, suitable for a brief overview."),
  fullPlot: z.string().describe("The full plot text for this ideated option. Copied to writtenPlot when selected."),
});

// =============================================================================
// TYPE INFERENCE
// =============================================================================

export type IdeatedPlot = z.infer<typeof IdeatedPlotSchema>;
